
-->
<style scoped lang="less">
  .floor2-wrapper{
    width: 1200px;
    margin: 0 auto;
    position: relative;
    margin-top: 30px;
    .list{
      .title{
        color: #ffc001;
        font-size: 16px;
        padding-left: 10px;
        line-height: 30px;
        margin-bottom: 10px;
      }
      .line{
        width: 320px;
        height: 3px;
        background-color: #ffc001;
        position: relative;
        &:before{
          content:'';
          display: block;
          position: absolute;
          left: 0;
          bottom:0;
          width: 1200px;
          height: 1px;
          background: #ccc;
        }
      }
      img{
        margin: 20px;
        width: 323px;
        height: 312px;
        cursor: pointer;
      }
    }
    .detail{
      .title{
        color: #ffc001;
        font-size: 16px;
        padding-left: 10px;
        line-height: 30px;
        margin-bottom: 10px;
      }
      .line{
        width: 320px;
        height: 3px;
        background-color: #ffc001;
        position: relative;
        &:before{
          content:'';
          display: block;
          position: absolute;
          left: 0;
          bottom:0;
          width: 1200px;
          height: 1px;
          background: #ccc;
        }
      }
      .content{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin: 30px 10px;
        img{
          width: 350px;
          height: 350px;
          margin-right: 30px;
        }
        .cont-r{
          color: #616161;
          .name{
            font-size: 22px;
            font-weight: 500;
            position: relative;
            padding-bottom: 10px;
            &:before{
              content:'';
              display: block;
              position: absolute;
              left: 0;
              bottom:0;
              width: 800px;
              height: 1px;
              background: #ccc;
            }
          }
          .price{
            color: #616161;
            margin-top: 10px;
            span{
              color: #ffc001;
              font-family: Arial;
              font-weight: 700;
              font-size: 24px;
            }
          }
          .num,.color{
            margin-top: 10px;
          }
          .buy{
            width: 140px;
            height: 37px;
            background-color: #ffc001;
            text-align: center;
            line-height: 37px;
            color: #fff;
            margin-top: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>

<template>
  <div class="floor2-wrapper">
    <div class="list" v-if="step === 1">
      <div class="title">	产品展示（医疗器械收费栏目，0.1元\条\天）</div>
      <div class="line"></div>
      <img src="https://img.gegejia.com/img/2cbf6ecdbecef5bf6134496efa844153.jpg" alt="" @click="goDetail">
    </div>
    <div class="detail" v-if="step === 2">
      <div class="title">产品详情</div>
      <div class="line"></div>
      <div class="content">
        <img src="https://img.gegejia.com/img/57c2f07674c621c4ebfef3433a016aa8.png" alt="">
        <div class="cont-r">
          <div class="name">血糖仪-医疗器械</div>
          <div class="price">零售价：	<span>￥385.00</span></div>
          <div class="num">库存：9999.00台</div>
          <div class="color">颜色：白色</div>
          <div class="buy">立即购买</div>
        </div>
      </div>
      <div class="banner">
        <img src="https://img.gegejia.com/img/f7aa2f385dd76c627049a4ce97d258f2.jpg" alt="">
        <img src="https://img.gegejia.com/img/6098a954c6834b3ee696115adf6fba55.jpg" alt="">
        <img src="https://img.gegejia.com/img/d45e2492d4fbeb5ef484047cba695df4.jpg" alt="">
        <img src="https://img.gegejia.com/img/7d114e43ee6fd84147ac6453d548162e.jpg" alt="">
        <img src="https://img.gegejia.com/img/981b1f91996c2cb28b40023636ed3969.jpg" alt="">
        <img src="https://img.gegejia.com/img/4e4b45169844df1239236cecddf200c5.jpg" alt="">
        <img src="https://img.gegejia.com/img/d271612935b0ac95cf5f84ec5a9056d5.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
 
export default {
  props:['step'],
  data() {
    return {
      
    };
  },
  methods: {
    goDetail() {
      this.$emit('goStep2', 2)
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/t97/block/floor2.vue